import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  AbcLoginComponentInfo,
  AbcProfileSelectionComponentInfo,
  AuthenticationGuard,
  ProfileSelectionGuardService,
} from '@barthauer/basys/core/authentication';
import { KAOSProfileSelectionComponent } from '@barthauer/kaos/core/authentication';
import { CoreComponent } from './core/core.component';
import { LoginComponent } from '@barthauer/custom/iddat';

const routes: Routes = [
  {
    path: AbcLoginComponentInfo.ROUTE_PATH,
    component: LoginComponent,
    data: {
      ApplicationTitle: 'Digitalization tool',
      MarkerTag: AbcLoginComponentInfo.ROUTE_MARKER_TAG,
      ForwardTo: AbcProfileSelectionComponentInfo.ROUTE_PATH,
      loginLogoPath: 'assets/images/custom/logoLogin.svg',
    },
  },
  {
    path: AbcProfileSelectionComponentInfo.ROUTE_PATH,
    component: KAOSProfileSelectionComponent,
    data: {
      ApplicationTitle: 'KAOS arena',
      ForwardTo: 'home',
      ForceReloadOnApply: false,
      MarkerTag: AbcProfileSelectionComponentInfo.ROUTE_MARKER_TAG,
    },
  },

  {
    path: '',
    component: CoreComponent,
    children: [
      {
        path: 'home',
        loadComponent: () => import('./core/home/home.component').then((module) => module.HomeComponent),
        canActivate: [ProfileSelectionGuardService],
      },
      {
        path: 'customer-history',
        loadComponent: () =>
          import('./core/customer-history/customer-history.component').then(
            (module) => module.CustomerHistoryComponent
          ),
        canActivate: [ProfileSelectionGuardService],
      },
      {
        path: 'qcm',
        loadChildren: () => import('./core/qcm/qcm.module').then((module) => module.QcmModule),
        canActivate: [ProfileSelectionGuardService],
      },
      {
        path: 'favorites',
        loadComponent: () =>
          import('./core/favorite-list/favorite-list.component').then((module) => module.FavoriteListComponent),
        canActivate: [ProfileSelectionGuardService],
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./core/dashboard/dashboard.component').then((module) => module.DashboardComponent),
        canActivate: [ProfileSelectionGuardService],
      },
      {
        path: 'evaluation/:auditId',
        loadComponent: () =>
          import('./core/evaluation/evaluation.component').then((module) => module.EvaluationComponent),
        canActivate: [ProfileSelectionGuardService],
      },
      {
        path: 'questions',
        loadComponent: () =>
          import('./core/question-list/question-list.component').then((module) => module.QuestionListComponent),
        canActivate: [ProfileSelectionGuardService],
      },
      {
        path: 'audits',
        loadComponent: () => import('./core/audit/audit.component').then((module) => module.AuditComponent),
        canActivate: [ProfileSelectionGuardService],
        data: { companyName: '', companyId: '' },
      },
      {
        path: 'responses',
        loadComponent: () =>
          import('./core/response-list/response-list.component').then((module) => module.ResponseListComponent),
        canActivate: [ProfileSelectionGuardService],
      },
      {
        path: 'libraries',
        loadComponent: () =>
          import('./core/library-list/library-list.component').then((module) => module.LibraryListComponent),
        canActivate: [ProfileSelectionGuardService],
      },
      {
        path: 'recommendations',
        loadComponent: () =>
          import('./core/measure-list/measure-list.component').then((module) => module.MeasureListComponent),
        canActivate: [ProfileSelectionGuardService],
      },
      {
        path: 'categories',
        loadComponent: () =>
          import('./core/category-list/category-list.component').then((module) => module.CategoryListComponent),
        canActivate: [ProfileSelectionGuardService],
      },
      // {
      //   path: 'staff-members',
      //   loadComponent: () =>
      //     import('./core/staff-members/staff-members.component').then((module) => module.StaffMembersComponent),
      //   canActivate: [ProfileSelectionGuardService],
      // },
      { path: '**', redirectTo: 'audits', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthenticationGuard],
})
export class AppRoutingModule {}
